// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"650cf5c8","133":"e904e008","182":"2e81ed47"}[chunkId] + ".chunk.js";
};